import { Box, Stack, Typography } from '@mui/material';
import tokens from '@verifime/design-tokens';
import { MultiFileUploaderView } from '../MultiFileUploaderView';
import { TDocumentsUploaderProps } from './types';

/**
 * Basic but flexible view component for DocumentsUploader.
 * Follows ADR 0062 three-layer architecture:
 *
 * This View component:
 * - Composes MultiFileUploaderView (handles API coordination)
 * - Adds title/subtitle UI for wizard context
 * - Does NOT handle API calls directly - delegates to MultiFileUploaderView
 * - Accepts ReactNode for title/subtitle for maximum flexibility
 */
export default function DocumentsUploader({
  entityId,
  documentType,
  title = 'Upload Supporting Documents',
  subtitle,
  isMultiple = true,
  isReadonly,
  onUploadingChange,
  onUploadedFilesChange,
}: TDocumentsUploaderProps) {
  return (
    <Stack
      width="100%"
      direction="column"
      gap={(theme) => theme.semantic.spacing.lg}
      data-component="documents-uploader"
    >
      <Box>
        {typeof title === 'string' ? (
          <Typography variant="h6">{title}</Typography>
        ) : (
          title
        )}
        {typeof subtitle === 'string' ? (
          <Typography variant="subtitle1">{subtitle}</Typography>
        ) : (
          subtitle
        )}
      </Box>
      <Box>
        <MultiFileUploaderView
          entityId={entityId}
          documentType={documentType}
          isMultiple={isMultiple}
          isReadonly={isReadonly}
          onUploadingChange={onUploadingChange}
          onFilesChange={onUploadedFilesChange}
        />
      </Box>
    </Stack>
  );
}
